import React from "react";
import LobbyQrCode from "./LobbyQrCode";

export const Lobby = () => {
  return <LobbyQrCode lg />;
};
